const articleSearchFragment = /* GraphQL */ `
  fragment articleSearchFragment on ProductResultPageResponse {
    articleSearchResponse {
      articleDetails {
        url
        title
        description
        articleThumbnailUrl
        id
        authors
      }
    }
  }
`

export default articleSearchFragment
